export enum BACKORDERS_STORAGE_KEYS {
  LocationPreference = "backorders-location-preference",
  DealerPreference = "backorders-dealer-preference",
  AppointmentDateFromPreference = "backorders-appointment-date-from-preference",
  AppointmentDateToPreference = "backorders-appointment-date-to-preference",
  DateFromPreference = "backorders-date-from-preference",
  DateToPreference = "backorders-date-to-preference",
  RegVinPreference = "backorders-reg-vin-preference",
  PageSizePreference = "backorders-page-preference"
}
